// extracted by mini-css-extract-plugin
export default {"center":"Loader_center__NdwK6","loader":"Loader_loader__RujVA","spin":"Loader_spin__lSz3s"};